import { currencyFormatter } from '@/helpers/currencyFormatter';

import { AdderType, BatteryType } from 'types';

import { useAccountDetailsContext } from './AccountDetailsContext';

interface UseAddersPropertiesParams {
  activeQuote: any;
  addersData: any;
  solarReadinessCost: number | undefined;
}

export function useAddersProperties({ activeQuote, addersData, solarReadinessCost }: UseAddersPropertiesParams) {
  const { id, isAccountEditEnabled } = useAccountDetailsContext();

  const addersMap = activeQuote?.adders?.reduce((acc: any, type: string) => {
    const adders = addersData?.adders?.filter((adder: any) => adder.type === type);

    if (adders?.length) {
      acc[type] = adders;
    } else {
      acc[type] = [];
    }

    return acc;
  }, {});
  const batteryAdderyType = addersMap?.arbitrageBattery ? BatteryType.arbitrageBattery : BatteryType.backupBattery;

  return {
    heading: 'Adders',
    editPath: isAccountEditEnabled ? `/accounts/${id}/adders` : undefined,
    values: [
      ...(addersMap?.[batteryAdderyType]
        ? addersMap[batteryAdderyType].map((adder: any) => ({
            label: `${addersMap?.arbitrageBattery ? 'Arbitrage' : 'Backup'} Battery`,
            value: [
              `${adder?.manufacturer ?? ''} ${adder?.model ?? ''}`,
              adder?.quantity ? `x${adder.quantity}` : 'Included',
            ],
          }))
        : []),
      ...(addersMap?.electricalUpgrade ? [{ label: 'Electrical Upgrade', value: 'Included' }] : []),
      ...(activeQuote?.adders?.includes(AdderType.solarReadiness)
        ? [{ label: 'Solar Readiness', value: currencyFormatter.format(solarReadinessCost ?? 0) }]
        : []),
      ...(!activeQuote?.adders?.length ? [{ label: 'None', value: '' }] : []),
    ],
  };
}
